import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export const Footer = () => {
  const [navbar, setNavbar] = useState([]);
  const [infoCompany, setInfoCompany] = useState(null);

  const getNavbarData = () => {
    axios
      .get("/navigation/public/shows")
      .then((res) => {
        setNavbar(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const getPageSection = () => {
    axios
      .get("/page-section/public/shows?sectionType=infoCompany")
      .then((res) => {
        setInfoCompany(res.data.data[0]);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getNavbarData();
    getPageSection();
  }, []);

  const userId = localStorage.getItem("userId");

  // Helper function to get content by key
  const getContentByKey = (key) => {
    if (!infoCompany || !infoCompany.content) return "";
    const item = infoCompany.content.find((item) => item.key === key);
    return item ? item.value : "";
  };

  // Helper function to get URL by key
  const getUrlByKey = (key) => {
    if (!infoCompany || !infoCompany.content) return "#";
    const item = infoCompany.content.find((item) => item.key === key);
    return item && item.url ? item.url : "#";
  };

  return (
    <footer>
      <div className="container-fluid text-white mt-5 pt-5">
        <div className="row px-xl-5 pt-5">
          <div className="col-lg-4 col-md-12 mb-5 pr-3 pr-xl-5">
            <h5 className=" text-uppercase mb-4">Thông tin công ty</h5>
            <h6 className=" mb-3">{getContentByKey("name")}</h6>
            <p className="mb-2">
              <i className="fa fa-map-marker-alt mr-3"></i>
              {getContentByKey("address")}
            </p>
            <p className="mb-2">
              <i className="fa fa-envelope mr-3"></i>
              {getContentByKey("email")}
            </p>
            <p className="mb-2">
              <i className="fa fa-phone-alt mr-3"></i>
              {getContentByKey("number_phone")}
            </p>
            {getContentByKey("fax") && (
              <p className="mb-2">
                <i className="fa fa-fax mr-3"></i>
                {getContentByKey("fax")}
              </p>
            )}
          </div>
          <div className="col-lg-8 col-md-12">
            <div className="row">
              <div className="col-md-4 mb-5">
                <h5 className=" text-uppercase mb-4">ĐIỀU HƯỚNG</h5>
                <div className="d-flex flex-column justify-content-start">
                  {navbar
                    ?.filter((item) => item.parentId === null)
                    .map((item, index) => (
                      <Link
                        className="text-white mb-2"
                        to={item.url}
                        key={index}
                      >
                        <i className="fa fa-angle-right mr-2"></i>
                        {item.title}
                      </Link>
                    ))}
                </div>
              </div>
              <div className="col-md-4 mb-5">
                <h5 className=" text-uppercase mb-4">Thời gian làm việc</h5>
                <div className="d-flex flex-column justify-content-start">
                  <p className=" mb-2">
                    <i className="fa fa-clock mr-2"></i>
                    {getContentByKey("working_fulltime")}
                  </p>
                  <p className=" mb-2">
                    <i className="fa fa-calendar-alt mr-2"></i>
                    {getContentByKey("working_parttime")}
                  </p>
                  <p className=" mb-2">
                    <i className="fa fa-headset mr-2"></i>
                    {getContentByKey("time_service")}
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-5">
                <h5 className=" text-uppercase mb-4 ">Tài khoản của tôi</h5>
                <div className="d-flex flex-column justify-content-start mb-4">
                  {userId ? (
                    <Link
                      to="#"
                      className="text-white mb-2"
                      style={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        localStorage.removeItem("accessToken");
                        localStorage.removeItem("userId");
                        localStorage.removeItem("avatar_url");
                        localStorage.removeItem("fullName");
                        window.location.href = "/";
                      }}
                    >
                      <i className="fa fa-angle-right mr-2"></i>Đăng xuất
                    </Link>
                  ) : (
                    <Link
                      to="/login"
                      className="text-white mb-2"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fa fa-angle-right mr-2"></i>Đăng nhập
                    </Link>
                  )}
                  <Link className="text-white mb-2" to="wishlist">
                    <i className="fa fa-angle-right mr-2"></i>Sản phẩm yêu thích
                  </Link>
                </div>

                <h6 className=" text-uppercase mb-3">Theo dõi chúng tôi</h6>

                <div className="d-flex flex-wrap">
                  {getUrlByKey("facebook") !== "#" && (
                    <Link
                      className="text-white bg-facebook btn-square mr-2 mb-2 rounded-circle border border-white"
                      to={getUrlByKey("facebook")}
                      target="_blank"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                  )}

                  {getUrlByKey("messenger") !== "#" && (
                    <Link
                      className="text-white bg-facebook btn-square mr-2 mb-2 rounded-circle border border-white"
                      to={getUrlByKey("messenger")}
                      target="_blank"
                      title="Messenger"
                    >
                      <i className="fab fa-facebook-messenger"></i>
                    </Link>
                  )}

                  {getUrlByKey("zalo") !== "#" && (
                    <Link
                      className="text-white bg-zalo btn-square mr-2 mb-2 rounded-circle border border-white"
                      to={getUrlByKey("zalo")}
                      target="_blank"
                      title="Zalo"
                    >
                      <span
                        className="text-sm font-weight-bold text-white"
                        style={{ fontSize: "12px" }}
                      >
                        Zalo
                      </span>
                    </Link>
                  )}

                  {getUrlByKey("tiktok") !== "#" && (
                    <Link
                      className="text-white bg-dark btn-square mr-2 mb-2 rounded-circle border border-white"
                      to={getUrlByKey("tiktok")}
                      target="_blank"
                      title="TikTok"
                    >
                      <i className="fab fa-tiktok"></i>
                    </Link>
                  )}

                  {getUrlByKey("youtube") !== "#" && (
                    <Link
                      className="text-white bg-danger btn-square mr-2 mb-2 rounded-circle border border-white"
                      to={getUrlByKey("youtube")}
                      target="_blank"
                      title="YouTube"
                    >
                      <i className="fab fa-youtube"></i>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 ">
          <div className="px-xl-0 text-center text-md-left">
            <p className="mb-md-0 text-center text-md-left ">
              Designed by{" "}
              <Link
                className="text-white"
                to="https://thietkeweb.katec.vn/"
                target="_blank"
              >
                Katec
              </Link>
            </p>
          </div>
          <div className="text-center text-md-right justify-self-end">
            <img className="img-fluid" src="img/payments.png" alt="" />
          </div>
        </div>
      </div>
    </footer>
  );
};
